import { render, staticRenderFns } from "./riwayat_jabatan_fungsional.vue?vue&type=template&id=3bb663b4&"
import script from "./riwayat_jabatan_fungsional.vue?vue&type=script&lang=js&"
export * from "./riwayat_jabatan_fungsional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports